import {useBalance} from "../../hooks/useBalance";
import {
    Group,
    Paper,
    Stack,
    Text,
    Title,
} from '@mantine/core';

const formatAmount = (amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency.toUpperCase(),
    }).format(amount / 100);
};

export const BalanceWidget = () => {

    const {balance, loading} = useBalance();

    return (
        <Paper shadow="sm" p="lg" radius="md" withBorder style={{flex: 1}}>
            <Stack gap="md">
                <Group justify="space-between">
                    <Title order={5}>Account Balance</Title>
                </Group>

                {loading ? (
                    <Text size="sm" c="dimmed">Loading...</Text>
                ) : !balance ? (
                    <Text size="sm" c="dimmed">Unable to load balance</Text>
                ) : (
                    <Stack gap="lg" py="md">
                        {balance.available.map((item, index) => (
                            <Group key={`available-${index}`} justify="space-between">
                                <Text size="sm" fw={500}>Available ({item.currency.toUpperCase()})</Text>
                                <Text size="lg" fw={700} c="green">{formatAmount(item.amount, item.currency)}</Text>
                            </Group>
                        ))}
                        {balance.pending.map((item, index) => (
                            <Group key={`pending-${index}`} justify="space-between">
                                <Text size="sm" fw={500}>Pending ({item.currency.toUpperCase()})</Text>
                                <Text size="lg" fw={700} c="yellow.7">{formatAmount(item.amount, item.currency)}</Text>
                            </Group>
                        ))}
                        {balance.connectReserved?.map((item, index) => (
                            <Group key={`reserved-${index}`} justify="space-between">
                                <Text size="sm" fw={500}>Connect Reserved ({item.currency.toUpperCase()})</Text>
                                <Text size="lg" fw={700} c="blue">{formatAmount(item.amount, item.currency)}</Text>
                            </Group>
                        ))}
                        {balance.instantAvailable?.map((item, index) => (
                            <Group key={`instant-${index}`} justify="space-between">
                                <Text size="sm" fw={500}>Instant Available ({item.currency.toUpperCase()})</Text>
                                <Text size="lg" fw={700} c="teal">{formatAmount(item.amount, item.currency)}</Text>
                            </Group>
                        ))}
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
};
